import useBuilder from 'base/react/hooks/useBuilder'

export default function BuilderConfiguration() {
  useBuilder()
  return null
}
